import React from 'react'
import SocialBar from '../../../SocialBar'

const LatestUpdates = () => (
  <div className="column">
    <p className="header">Get Our Latest Updates</p>
    <SocialBar />
  </div>
)

export default LatestUpdates
